import {
	bidSuretyBondClosedReasonDef,
	ContractSuretyType,
	finalContractSuretyBondClosedReasonDef,
	SuretyBondStatus,
} from "@inrev/common";
import type { DropdownOption } from "./types";

// View-specific option labels; enum-backed options (e.g. issuance method) use the enum's options() at the usage site.
export const BID_BOND_AMOUNT_TYPE_OPTIONS: DropdownOption[] = [
	{ label: "Percent", value: "percent" },
	{ label: "Dollars", value: "dollars" },
];

export const CONTRACT_SURETY_TYPE_OPTIONS: DropdownOption[] = [
	{ label: "Bid", value: ContractSuretyType.bid },
	{ label: "Final (From Bid)", value: ContractSuretyType.bid_to_final },
	{ label: "Final", value: ContractSuretyType.final },
];

export const BOND_STATUS_OPTIONS: DropdownOption[] = [
	{ label: "Open", value: SuretyBondStatus.open },
	{ label: "Closed", value: SuretyBondStatus.closed },
];

export const BOND_FORM_TYPE_OPTIONS: DropdownOption[] = [
	{ label: "Performance & Payment", value: "pnp" },
	{ label: "Performance", value: "performance" },
	{ label: "Payment", value: "payment" },
];

export const BID_CLOSED_REASON_OPTIONS: DropdownOption[] = bidSuretyBondClosedReasonDef.map(
	(reason) => ({ label: reason, value: reason }),
);

export const FINAL_CLOSED_REASON_OPTIONS: DropdownOption[] =
	finalContractSuretyBondClosedReasonDef.map((reason) => ({ label: reason, value: reason }));
